import { Outlet } from 'react-router-dom'
import { AccountSidebar, AccountMobileNav } from '@/components/account/account-sidebar'
import { SiteHeader } from '@/components/site-header'
import { CartDrawer } from '@/components/cart/cart-drawer'

export function AccountLayout() {
  return (
    <div className="flex flex-col min-h-screen">
      <SiteHeader />
      <CartDrawer />
      <div className="flex flex-1">
        <AccountSidebar />
        <div className="flex-1 flex flex-col">
          <AccountMobileNav />
          <main className="flex-1 p-6 md:p-8 bg-muted/30">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  )
}
